PandoInboxController.$inject = ["$rootScope", "pandoCommunicationService", "crossDomainStorageService", "storageService", "dealerService"];
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.object.set-prototype-of.js";
/* injects from baggage-loader */
require('./pando-inbox.component.html');
import angular from 'angular';
import Pubnub from 'pubnub';
import { OpportunitiesModule } from '../../core/opportunities.module';
OpportunitiesModule.component('pandoInbox', {
  templateUrl: '/app/components/header/pando-inbox.component.html',
  controller: PandoInboxController,
  bindings: {
    isAutoAlertUser: '<'
  }
});

/* @ngInject */
function PandoInboxController($rootScope, pandoCommunicationService, crossDomainStorageService, storageService, dealerService) {
  var $ctrl = this;
  $ctrl.$onInit = $onInit;
  $ctrl.isAvailable = null;
  $ctrl.Availability = null;
  $ctrl.unreadMessageCount = null;
  //$ctrl.loginUserChatId = null;

  $ctrl.messages = [];
  $ctrl.messageGroupIds = [];
  $ctrl.communicationUrl = null;
  var accountControlChannel = null;
  var userControlChannel = null;
  var inboxConfig = {};
  //$ctrl.currentUserVenderInfo = null;
  $ctrl.loginUserId = null;
  var pandoMessaging = new PandoMessaging();
  function $onInit() {
    inboxConfig = pandoCommunicationService.getPandoInboxConfig();
    if (!inboxConfig.enabled) {
      $ctrl.pandoInboxEnabled = false;
      return;
    }
    $ctrl.pandoInboxEnabled = true;
    $ctrl.communicationUrl = inboxConfig.pandoInboxUrl;
    setupPubnubMessaging();
  }

  // setup pubnub
  function setupPubnubMessaging() {
    return pandoCommunicationService.getMessageVendorInfo($ctrl.isAutoAlertUser).then(function (vendorInfo) {
      if (vendorInfo) {
        // if user does not have subkey exit
        if (vendorInfo.SubscriptionKey == null || vendorInfo.SubscriptionKey == '') return;
        // if user does not have auth key exit
        if (vendorInfo.AuthorizationKey == null || vendorInfo.AuthorizationKey == '') return;
        //$ctrl.currentUserVenderInfo = vendorInfo;
        var userIds = vendorInfo.UserControl.split("-");
        $ctrl.loginUserId = "1:" + userIds[2];
        accountControlChannel = vendorInfo.AccountControl;
        userControlChannel = vendorInfo.UserControl.UserControl;
        pandoMessaging.initPubnub(vendorInfo.SubscriptionKey, vendorInfo.AuthorizationKey, vendorInfo.Channels, vendorInfo.ChannelGroups);
        pandoMessaging.subscribe(pubnubMessageCallback);
        if ($ctrl.unreadMessageCount == null) {
          getApiMessageCount(); // call motofuze api to show count
        }
        $ctrl.isUserAuthorisedForPando = true;
      }
    }, function (error) {
      return null;
    });
  }
  function pubnubMessageCallback(_x) {
    return _pubnubMessageCallback.apply(this, arguments);
  }
  function _pubnubMessageCallback() {
    _pubnubMessageCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(msgResponseObject) {
      var rtid, dealers, dealerGroupId, selectedStores, i, dealerInfo, dealer, dealerDisplayText, sortedDealers, fullData, cookieData, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!(!msgResponseObject || !msgResponseObject.message || !msgResponseObject.message.rtid)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            rtid = msgResponseObject.message.rtid;
            _t = rtid;
            _context.n = _t === 111 ? 2 : _t === 112 ? 2 : _t === 113 ? 2 : _t === 114 ? 2 : _t === 126 ? 2 : _t === 27 ? 3 : 9;
            break;
          case 2:
            // This list of values provieded by Satish on the KC team
            if (msgResponseObject.message.pn_apns && msgResponseObject.message.pn_apns.aps && msgResponseObject.message.pn_apns.aps.hasOwnProperty('badge')) {
              $ctrl.unreadMessageCount = msgResponseObject.message.pn_apns.aps.badge;
            }
            return _context.a(3, 9);
          case 3:
            if (!(msgResponseObject.message.msg && msgResponseObject.message.msg.SelectedStores)) {
              _context.n = 8;
              break;
            }
            dealers = [];
            dealerGroupId = msgResponseObject.message.msg.DealerGroupID;
            selectedStores = msgResponseObject.message.msg.SelectedStores;
            i = 0;
          case 4:
            if (!(i < selectedStores.length)) {
              _context.n = 7;
              break;
            }
            _context.n = 5;
            return fetchDealerInfo(selectedStores[i].DealerID);
          case 5:
            dealerInfo = _context.v;
            dealer = {
              id: selectedStores[i].DealerID,
              name: dealerInfo ? dealerInfo.displayText : selectedStores[i].Name
            };
            dealers.push(dealer);
          case 6:
            i++;
            _context.n = 4;
            break;
          case 7:
            dealerDisplayText = msgResponseObject.message.msg.SelectedStores.length == 1 ? dealers[0].name : msgResponseObject.message.msg.Name; //dealerGroupName
            sortedDealers = [].concat(dealers).sort(function (a, b) {
              return a.name.localeCompare(b.name);
            });
            fullData = {
              dealers: sortedDealers,
              dealerGroupId: dealerGroupId,
              dealerDisplayText: dealerDisplayText
            };
            storageService.setItem('selectedDealers', fullData);
            cookieData = {
              dealers: sortedDealers.map(function (d) {
                return {
                  id: d.id
                };
              }),
              dealerGroupId: dealerGroupId,
              dealerDisplayText: dealerDisplayText
            };
            crossDomainStorageService.setItem('selectedDealers', cookieData);
          case 8:
            return _context.a(3, 9);
          case 9:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _pubnubMessageCallback.apply(this, arguments);
  }
  function fetchDealerInfo(_x2) {
    return _fetchDealerInfo.apply(this, arguments);
  } // first time call does not use pubnub but calls api to get messages
  function _fetchDealerInfo() {
    _fetchDealerInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dealerId) {
      var dealerInfo;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            dealerInfo = dealerService.getDealer(dealerId).then(function (dealerInfo) {
              return dealerInfo;
            });
            return _context2.a(2, dealerInfo);
        }
      }, _callee2);
    }));
    return _fetchDealerInfo.apply(this, arguments);
  }
  function getApiMessageCount() {
    return pandoCommunicationService.getUnreadMessageCount($ctrl.isAutoAlertUser).then(function (result) {
      processApiMessageCollection(result);
    });
  }

  // display unread messages based on API call
  function processApiMessageCollection(data) {
    if (!data || !data.hasOwnProperty('msgcount')) return;
    $ctrl.unreadMessageCount = data.msgcount;
  }
  function getBadgeCountUserInfo(data, userId) {
    var badgeCount = typeof data.MessageBadgeCount != "undefined" ? data.MessageBadgeCount : '0';
    var senderId = userId ? userId : '';
    var groupName = data.GroupName ? data.GroupName : '';
    var groupId = data.GroupId ? data.GroupId : '';
    var messageBadgeCountUserInfo = {
      'MessageBadgeCount': badgeCount,
      'UserId': senderId,
      'GroupName': groupName,
      'GroupId': groupId
    };
    return messageBadgeCountUserInfo;
  }
}
function PandoMessaging() {
  // instantiating PubNub generates a UUID for you and stores it in localStorage
  // and reuses that UUID from localStorage on subsequent PubNub instantiations
  var uuid;
  var pubnub;
  var channels = [];
  var channelGroups = [];
  var pandoInboxUrl;
  function addListenerPubnub() {
    pubnub.addListener({
      // message events callback - handles all messages published to the subscribed channels
      message: function message(event) {
        sendPandoChatMessage(event);
      },
      // presence events callback - handles all presence events for all channels subscribed withPresence
      presence: function presence(event) {},
      // status events callback - handles network connectivity status events for all subscribed channels
      status: function status(event) {}
    });
  }
  function subscribePubnub() {
    // subscribe to the game channel and monitor presence events on that channel
    pubnub.subscribe({
      channels: channels,
      channelGroups: channelGroups,
      error: function error(_error) {
        //console.log(error);
      }
    });
  }
  var subscriptions = [];
  function sendPandoChatMessage(message) {
    for (var _i = 0, _subscriptions = subscriptions; _i < _subscriptions.length; _i++) {
      var fn = _subscriptions[_i];
      try {
        fn(message);
      } catch (e) {
        //console.log("sendMessageToiFrame Error:" + e);
      }
    }
  }
  return {
    initPubnub: function initPubnub(subKey, authKey, pandoChannels, pandoChannelGroups) {
      channels = pandoChannels;
      channelGroups = pandoChannelGroups;
      pubnub = new Pubnub({
        subscribeKey: subKey,
        authKey: authKey,
        //publishKey: PubNubSubscribeKey,
        ssl: true
      });
      uuid = pubnub.getUUID();
      addListenerPubnub();
      subscribePubnub();
    },
    subscribe: function subscribe(fn) {
      subscriptions.push(fn);
      return {
        unsubscribe: function unsubscribe() {
          var ix = subscriptions.indexOf(fn);
          if (ix > -1) {
            subscriptions.splice(ix, 1);
          }
        }
      };
    },
    quitPandoChat: function quitPandoChat() {
      pubnub.unsubscribe({
        channels: channels,
        channelGroups: channelGroups,
        callback: function callback(msg) {
          //console.log(msg);
        }
      });
    }
  };
}